import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { FiLogOut, FiUser, FiShield } from 'react-icons/fi'

function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated, isAdmin, user, logout } = useAuthStore()

  const handleLogout = async () => {
    await logout()
    navigate('/auth')
  }

  if (!isAuthenticated) return null

  return (
    <header className="bg-bg-card border-b border-border-dark sticky top-0 z-50">
      <div className="max-w-7xl 2xl:max-w-screen-2xl 3xl:max-w-screen-3xl 4xl:max-w-screen-4xl mx-auto px-4 sm:px-6 lg:px-8 2xl:px-16 3xl:px-24 py-0">

        {/* Mobile layout */}
        <div className="flex sm:hidden items-center py-2">
          <button
            onClick={() => navigate('/profile')}
            className={`flex items-center px-2 py-2 rounded transition ${
              location.pathname === '/profile' ? 'bg-accent-teal text-white' : 'text-gray-300 hover:text-white'
            }`}
            title="Profile"
          >
            <FiUser size={16} />
          </button>
          {isAdmin && (
            <button
              onClick={() => navigate('/admin')}
              className={`flex items-center px-2 py-2 rounded transition ${
                location.pathname === '/admin' ? 'bg-accent-teal text-white' : 'text-gray-300 hover:text-white'
              }`}
              title="Admin"
            >
              <FiShield size={16} />
            </button>
          )}
          <button onClick={() => navigate('/')} className="flex-1 flex flex-col items-center hover:opacity-80 transition">
            <h1 className="text-base font-bold text-accent-teal">Case Sizing Engine</h1>
            <p className="text-xs text-accent-yellow">Input your specs, we do the work. You get the perfect case!</p>
          </button>
          <button
            onClick={handleLogout}
            className="flex items-center px-2 py-2 text-gray-300 hover:text-accent-yellow transition"
            title="Logout"
          >
            <FiLogOut size={16} />
          </button>
        </div>

        {/* Desktop layout */}
        <div className="hidden sm:flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-3 hover:opacity-80 transition">
            <h1 className="text-xl font-bold text-accent-teal">Case Sizing Engine</h1>
          </button>
          <p className="text-sm text-accent-yellow">Input your specs, we do the work. You get the perfect case!</p>
          <div className="flex items-center gap-4">
            {isAdmin && (
              <button
                onClick={() => navigate('/admin')}
                className={`flex items-center gap-2 px-4 py-2 rounded transition ${
                  location.pathname === '/admin' ? 'bg-accent-teal text-white' : 'text-gray-300 hover:text-white'
                }`}
                title="Admin"
              >
                <FiShield size={16} />
                <span className="text-xs">Admin</span>
              </button>
            )}
            <button
              onClick={() => navigate('/profile')}
              className={`flex items-center gap-2 px-4 py-2 rounded transition ${
                location.pathname === '/profile' ? 'bg-accent-teal text-white' : 'text-gray-300 hover:text-white'
              }`}
              title="Profile"
            >
              <FiUser size={16} />
              <span className="text-xs">{user?.displayName || user?.email}</span>
            </button>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:text-accent-yellow transition"
              title="Logout"
            >
              <FiLogOut size={16} />
              <span className="text-xs">Logout</span>
            </button>
          </div>
        </div>

      </div>
    </header>
  )
}

export default Header
